"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.StarIcon24Solid = forwardRef_1.forwardRef('StarIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M10.967 1.8c.39-.908 1.676-.908 2.066 0l2.53 5.875 6.37.59c.984.092 1.381 1.315.64 1.966l-4.807 4.222 1.407 6.241c.217.963-.823 1.719-1.672 1.215L12 18.643l-5.5 3.266c-.85.504-1.89-.252-1.673-1.215l1.407-6.24-4.806-4.223c-.742-.651-.345-1.874.638-1.965l6.37-.591 2.53-5.876Z" })));
});
